export const ToastMessage = {
  errorMessage: `Ballot not created due to an unexpected error. Please try again or contact IT Support if issue persists.`,
  successMessage: `Ballot was successfully created.`,
}


export const BallotTypes = {
  SRS: `Systematic Review Ballot`
}
